{{ errorMessage ? errorMessage : '' }}

<div class="system-poster">
  <div class="inner-border">
    <div class="corner-number">{{ systemNumber }}</div>
    <div class="poster-content">
      <div class="qr-code" *ngIf="urlQrCode">
        <img [src]="urlQrCode" alt="QR Code" />
      </div>
      <div class="poster-text">
        <div class="flag-row">
          <img src="assets/images/flags/no.png" alt="Norwegian" title="Norwegian" class="flag-icon" />
        </div>
        <ol class="styled-numbers">
          <li>Scann QR med mobilkamera for å åpne appen</li>
          <li>Legg ønsket vare i handlekurven</li>
          <li>Gå til kassen og betal</li>
          <li>Hent varen din</li>
        </ol>
        <!-- <hr /> -->
        <div class="flag-row">
          <img src="assets/images/flags/gb.png" alt="English" title="English" class="flag-icon" />
        </div>
        <ol class="styled-numbers">
          <li>Scan the QR code with your mobile camera to open the app</li>
          <li>Add the desired product to your cart</li>
          <li>Go to checkout and pay</li>
          <li>Collect your product</li>
        </ol>
      </div>
      
          <img src="assets/img/frigg-icon.png" alt="Frigg watermark" title="Frigg watermark" class="water-mark" />
    </div>
  </div>
</div>